import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";
import FieldsBuildingContact from 'graphql/fields/FieldsBuildingContact'

const fields = {
	'guid': 'String!',
};

export default gql(`
	query building_contact( ${ HelperGraphql.createFields( fields ) } ) {
		building_contact( ${ HelperGraphql.createVariables( fields ) } ) {
			${FieldsBuildingContact}
			
			language {
				guid
			}
		}
	}
`);

